<template>
  <div class="refund-review">
    <Search :renderData="renderData" :formData="form" :labelWidth="100" @onSearch="onSearch"></Search>
    <Table :tableThData="tableThData" :tableTrData="tableTrData" :loading="loading" :limit="limit" :total="total"
      :offset="offset" v-on:handleSizeChange="handleSizeChange" v-on:handleCurrentChange="handleCurrentChange">
      <template #paymentOrderId="{ row }">{{ row.paymentOrderId }}</template>
      <template #activityName="{ row }">{{ row.activityName }}</template>
      <template #mallName="{ row }">{{ row.mallName }}</template>
      <template #phone="{ row, scope }">
        <span :key="tableKey">{{ row.phone_show || row.phone }}</span>
        <auth-button auth="user:phone:read">
          <el-button v-if="row.phone" class="look-phone-btn"  type="text" @click="onLookPhone(row, scope.$index)">
            {{ row.phone_show ? '隐藏' : '查看' }}
          </el-button>
        </auth-button>
      </template>
      <template #source="{ row }">{{ row.source }}</template>
      <template #amount="{ row }">{{ row.amount ? row.amount + '元' : '' }}</template>
      <template #refundAmount="{ row }">{{ row.refundAmount ? row.refundAmount + '元' : '' }}</template>
      <template #status="{ row }">
        <span :class="row.status + ' status'"></span>
        {{ getStatusName(row.status) }}
      </template>
      <template #created="{ row }">{{ row.created ? $moment(row.created).format('YYYY/MM/DD HH:mm:ss') : '---'
      }}</template>
      <template #reason="{ row }">{{ row.reason ? row.reason : '---'}}</template>
      <template #remark="{ row }">{{ row.remark ? row.remark : '---'}}</template>
      <template #auditTime="{ row }">{{ row.auditTime ? $moment(row.auditTime).format('YYYY/MM/DD HH:mm:ss') : '---'
      }}</template>
      <template #operatorName="{ row }">{{ row.operatorName ? row.operatorName : '---'}}</template>
      <template #operation="{ scope }">
        <auth-button auth="refundapply:update">
          <el-button v-if="scope.row.status == 'RefundApply'" type="text" @click="onAgree(scope.row)" class="mr10">同意</el-button>
          <el-button v-if="scope.row.status == 'RefundApply'" class="del" type="text" @click="onRefuse(scope.row)">拒绝</el-button>
        </auth-button>
      </template>
    </Table>
    <Dialog :dialogShow="showDialog" :title="'拒绝'" :maskClose="false">
      <template>
        <div class="edit-dialog">
          <el-form ref="editForm" :model="editForm" hide-required-asterisk label-width="100px">
            <el-form-item label="拒绝原因" prop="remark" :rules="[{ required: true, message: '请输入拒绝原因' }]">
              <el-input type="textarea" rows="6" show-word-limit placeholder="请输入拒绝原因" :maxlength="500" v-model="editForm.remark" class="input">
              </el-input>
            </el-form-item>
          </el-form>
          <div class="dialog-footer">
            <el-button @click="showDialog = false" class="mr10">取消</el-button>
            <el-button type="primary" @click="onSubmit" :loading="submitLoading">确定</el-button>
          </div>
        </div>
      </template>
    </Dialog>
  </div>
</template>
<script>
import { api_postRefundApplyPage, api_postRefundPage } from '@/api/finance'
import { api_getUserPhone } from '@/api/common'
import aes from '@/common/aes.js'
import tableList from '@/mixins/tableList';
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
import Dialog from '@/components/Dialog/index'
import AuthButton from '@/components/AuthButton'
export default {
  name: "OIndex",
  mixins: [tableList],
  components: {
    AuthButton,
    Search,
    Table,
    Dialog
  },
  data() {
    return {
      tableKey: false,
      renderData: [
        {
        label: "状态",
        placeholder: "请选择状态",
        type: "select",
        multiple: false,
        key: "status",
        option: [{
          value: 'RefundApply',
          label: '待审核'
        },{
          value: 'Approved',
          label: '已通过'
        }, {
          value: 'Reject',
          label: '已拒绝'
        },]
      },
      {
        label: "订单编号",
        placeholder: "请输入订单编号",
        type: "input",
        key: "paymentOrderId",
      },
      {
        label: "会员手机号",
        placeholder: "请输入会员手机号",
        type: "input",
        key: "phone",
        maxLength: 11,
        isNumber: true
      },
      {
        label: "发起端",
        placeholder: "请选择发起端",
        type: "select",
        multiple: false,
        key: "source",
        option: [{
          value: 'WechatMiniapp',
          label: '微信小程序'
        },{
          value: 'Cashier',
          label: '收银台'
        }],
      }],
      form: {
        status: 'RefundApply'
      },
      tableThData: [
        { prop: "paymentOrderId", label: "订单编号", minWidth: "150", },
        { prop: "activityName", label: "活动名称", minWidth: "250", },
        { prop: "mallName", label: "所属商场", minWidth: "150", },
        { prop: "phone", label: "会员手机号", minWidth: "150", },
        { prop: "source", label: "发起端", minWidth: "120", },
        { prop: "amount", label: "订单金额", minWidth: "120", },
        { prop: "refundAmount", label: "退款金额", minWidth: "120", },
        { prop: "created", label: "提交时间", minWidth: "180", },
        { prop: "status", label: "状态", minWidth: "100", },
        { prop: "reason", label: "退款原因", minWidth: "150", },
        { prop: "remark", label: "拒绝原因", minWidth: "150", },
        { prop: "auditTime", label: "审核时间", minWidth: "180", },
        { prop: "operatorName", label: "操作人", minWidth: "100", },
        { prop: "operation", label: "操作", minWidth: "180", },
      ],
      showDialog: false,
      editForm: {
        paymentOrderId: '',
        status: 'Reject',
        remark: '',
        id: ''
      },
      submitLoading: false
    };
  },
  created() {
  },
  methods: {
    // 点击查看手机号
    async onLookPhone(row, index) {
      try {
        if (row.phone_show) {
          delete this.tableTrData[index].phone_show
        } else {
          const {phone} = await api_getUserPhone({id: row.userId})
          this.tableTrData[index].phone_show = aes.decrypt(phone)
        }
        this.tableKey = !this.tableKey
      } catch (error) {}
    },
    // 获取表格列表数据
    async getList() {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({ query: params })
      const data = await api_postRefundApplyPage(params)
      this.tableTrData = data.list || []
      this.total = data.count
      this.loading = false
    },
    onAgree(row) {
      this.$baseConfirm(
        '是否同意此退款申请？',
        {
          title: '提示',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showClose: false,
          type: 'warning',
        },
        async () => {
          let params = {
            paymentOrderId: row.paymentOrderId,
            id: row.id,
            status: 'Approved',
          }
          await api_postRefundPage(params)
          this.$baseMessage('操作成功', 'success')
          this.getList()
        }
      )
    },
    onRefuse(row) {
      this.editForm.paymentOrderId = row.paymentOrderId
      this.editForm.id = row.id
      this.editForm.remark = ''
      this.showDialog = true
    },
    onSubmit() {
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          let params = {
            ...this.editForm,
          }
          try {
            await api_postRefundPage(params)
            this.$baseMessage('操作成功', 'success')
            this.submitLoading = false
            this.getList()
            this.showDialog = false
          } catch {
            this.submitLoading = false
          }
        }
      })
    },
    getStatusName(status) {
      switch (status) {
        case 'RefundApply':
          return '待审核'
        case 'Reject':
          return '拒绝'
        case 'Approved':
          return '已通过'
      }
    },
  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.refund-review {
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;

  .fun-btn-box {
    margin-top: 20px;
  }

  .status {
    width: 6px;
    height: 6px;
    display: inline-block;
  }

  .FINISHED {
    background: #05c8af;
    border-radius: 50%;
    vertical-align: middle;
  }

  .RefundApply {
    background: #3775FF;
    border-radius: 50%;
    vertical-align: middle;
  }

  .Approved {
    background: #05c8af;
    border-radius: 50%;
    vertical-align: middle;
  }

  .Reject {
    background: #F74A4A;
    border-radius: 50%;
    vertical-align: middle;
  }

  .del {
    color: #F74A4A;
  }

  .edit-dialog {
    padding-top: 20px;
    position: relative;

    .dialog-footer {
      text-align: right;
    }

    ::v-deep {
      .el-select {
        width: 100%;
      }

      .el-form-item {
        &.notes {
          margin-bottom: 32px;

          .el-form-item__content {
            &::before {
              position: absolute;
              left: 0;
              bottom: -22px;
              content: '( 填写“0”表示永久有效 )';
              width: 140px;
              height: 17px;
              line-height: 17px;
              font-size: 12px;
              color: #666666;
            }

            .el-form-item__error {
              height: 17px;
              left: 140px;
              padding-top: 7px;
            }
          }
        }
      }
    }
  }
}
</style>
